require("style!css!less!./font-awesome-styles!./font-awesome.config.js");



/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome-webpack/index.js
 ** module id = 477
 ** module chunks = 0
 **/